import { useEffect, useState } from 'react';
import { unitsApiKeyStore } from '../../../../api/units-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { columns } from './lots-grid-columns';
import { State } from '@progress/kendo-data-query';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import useDebounce from '../../../../hooks/use-debounce';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useSaveData } from '../../../../hooks/useSaveData';
import { Unit } from 'chart.js/dist/scales/scale.time';

interface ProjectsTabProps {
  officeID: number;
}
export const LotsTab = ({ officeID }: ProjectsTabProps) => {
  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Office Details', 'Unit'));

  const {
    isLoading,
    data: units,
    refetch,
  } = useLoadData<ApiResponse<Unit[]>>(unitsApiKeyStore.getOfficeUnits(officeID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredUnits, setFilteredUnits] = useState<any[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredUnitList = units?.data?.filter((unit) =>
      Object.values(unit).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredUnits(filteredUnitList || []);
  }, [debouncedSearchTerm, units?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Unit',
      pageName: 'Office Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Unit',
      pageName: 'Office Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);
  return (
    <SiTrackGrid
      fileTitle='office_lot'
      columns={columns}
      dataItemKey="unitID"
      queryConfig={unitsApiKeyStore.getOfficeUnits(officeID)}
      viewRoute={(value) => `/units/profile/${value.unitID}`}
      actionPermissions={{
        view: UserPermissionName.VIEW_UNIT,
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      // -----------------Grid Layout-------
      dataItems={filteredUnits || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
